module.exports = __webpack_public_path__ + "img/55ne.a8603aca.svg";